<template>
  <div class="app">
    <AppHeader style="height: 44%">
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="../../public/img/brand/logo.png"
          width="100%"
          height="100%"
          alt="Accesys Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="../../public/img/brand/sygnet.png"
          width="30"
          height="30"
          alt="Accesys Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <div class="ml-auto">
          <span
            class="mr-1"
            :cnpj="getCnpj()"
            :enterprise="getEnterprise()"
            :user="getUser()"
          >
            <b>Cnpj: </b>{{ cnpj }}
            <br />
            <b>Empresa: </b>{{ enterprise }}
            <br />
            <b>Usuário: </b> {{ user }}</span
          >
        </div>
        <DropdownContainer />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed> </AppAside>
    </div>
    <TheFooter>
      <div>
        <a href="https://www.accesys.com.br/" target="_blank"
          >Accesys Solutions</a
        >
        <span class="ml-1">&copy; 2019.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Feito com</span>
        <a href="https://vuejs.org/">VueJS</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DropdownContainer from "./DropdownContainer";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DropdownContainer,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      nav: nav.items,
      user: null,
      enterprise: null,
      cnpj: null,
    };
  },
  methods: {
    getUser() {
      this.user = localStorage.getItem("user");
    },
    getEnterprise() {
      this.enterprise = localStorage.getItem("enterprise_fantasy");
    },
    getCnpj() {
      this.cnpj = localStorage.getItem("cnpj");
    },
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
};
</script>

